import { reactive, ref, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import * as validation from '@/util/validation'
import * as apiPasswordReminder from '@/api/password-reminder'
import * as apiProfile from '@/api/profile'
import { getQueryParam } from '@/util/common'

/**
 * パスワードを忘れた方 メールアドレス入力画面
 */
export const getEmailInput = () => {

  const group1 = reactive({
    // フォーム入力値
    email: '',
    email_check: '',

    // フォーム入力エラーメッセージ
    error_email: '',
    error_email_check: '',

    /**
     * 次へボタンを押下した時
     */
    submitButtonClicked: () => {
      // エラーメッセージを初期化
      group1.error_email = ''
      group1.error_email_check = ''

      let isError = false

      // メールアドレス
      if (group1.email === '') {
        group1.error_email = '必須項目です。'
        isError = true
      } else if (!validation.checkHankaku(group1.email) || !validation.checkMaxLength(group1.email, 50)) {
        group1.error_email = '半角50文字以内で入力してください。'
        isError = true
      } else if (!validation.checkEmailFormat(group1.email)) {
        group1.error_email = '正しいメールアドレスを入力してください。'
        isError = true
      }
      if (group1.email_check === '') {
        group1.error_email_check = '必須項目です。'
        isError = true
      } else if (!validation.checkHankaku(group1.email_check) || !validation.checkMaxLength(group1.email_check, 50)) {
        group1.error_email_check = '半角50文字以内で入力してください。'
        isError = true
      } else if (!validation.checkEmailFormat(group1.email_check)) {
        group1.error_email_check = '正しいメールアドレスを入力してください。'
        isError = true
      } else if (group1.email !== group1.email_check) {
        group1.error_email_check = 'メールアドレスが一致していません。'
        isError = true
      }

      if (isError) {
        // 入力エラーが存在した場合
        return false
      }

      const params = {
        email: group1.email
      }

      store.dispatch('common/showLoading')
      apiPasswordReminder.requestForChange(params)
        .then(response => {

          if (response) {
            const { data } = response

            if (data) {
              const status = data.status ?? -1
              const errorMessage = data.error_message ?? ''

              if (status === 0) {
                // status=0: 成功

                router.push({ path: '/public/password-reminder/complete' })
              } else {
                // status=その他: エラーダイアログを表示
                store.dispatch('common/showNotice', { title: 'エラー', text: response.data.error_message })
              }
            }
          }
        })
        .finally(() => {
          store.dispatch('common/hideLoading')
        })
    }
  })

  return group1
}

/**
 * パスワードを忘れた方 パスワード入力画面
 */
export const getPasswordInput = () => {

  const group1 = reactive({
    // フォーム入力値
    password: '',
    password_check: '',

    // 表示用
    name: '',
    isPasswordTypeDisplay: true,
    isPasswordType: computed(() => group1.isPasswordTypeDisplay ? 'password' : 'text'),
    isPasswordTypeDisplay2: true,
    isPasswordType2: computed(() => group1.isPasswordTypeDisplay2 ? 'password' : 'text'),

    // フォーム入力エラーメッセージ
    error_password: '',
    error_password_check: '',

    /**
     * 初期表示
     */
    init: () => {
      const token = getQueryParam('token')
      // ストアにtokenの値入れる
      store.dispatch('auth/setToken', { token: token })

      // プロフィール取得APIをコール
      const params = {
        type: 2 // 2=パスワード変更（パスワードを忘れた方）
      }
      apiProfile.fetch(params)
        .then(response => {

          if (response) {
            const { data } = response

            if (data) {
              const status = data.status ?? -1
              const errorMessage = data.error_message ?? ''

              if (status === 0) {
                // status=0: 成功
                group1.name = data.name

              } else if (status === 400) {
                // status=400: トークンが間違っている
                store.dispatch('common/showErrorInFullScreen', {title: '認証エラー', text: 'URLの認証に失敗しました。最初から入力手続きをお願いします。'})
              } else if (status === 401) {
                // status=400: トークンの有効期限が過ぎている
                store.dispatch('common/showErrorInFullScreen', {title: 'タイムアウト', text: 'URLの有効期限を過ぎています。ログイン画面に戻り、再度操作をお願いします。'})
              } else {
                // status=その他: エラーダイアログを表示
                store.dispatch('common/showNotice', { title: 'エラー', text: response.data.error_message })
              }
            }
          }
        })
    },

    /**
     * 次へボタンを押下した時
     */
    submitButtonClicked: () => {
      // エラーメッセージを初期化
      group1.error_password = ''
      group1.error_password_check = ''

      let isError = false

      // パスワード
      if (group1.password === '') {
        group1.error_password = '必須項目です。'
        isError = true
      } else if (!validation.checkHankaku(group1.password) || !validation.checkMinLength(group1.password, 8)) {
        group1.error_password = '半角8文字以上で入力してください。'
        isError = true
      } else if (!validation.checkHankaku(group1.password) || !validation.checkMaxLength(group1.password, 16)) {
        group1.error_password = '半角16文字以内で入力してください。'
        isError = true
      }
      if (group1.password_check === '') {
        group1.error_password_check = '必須項目です。'
        isError = true
      } else if (group1.password !== group1.password_check) {
        group1.error_password_check = '新しいパスワードと新しいパスワード（確認）が一致しません。'
        isError = true
      }

      if (isError) {
        // 入力エラーが存在した場合
        return false
      }

      const params = {
        password: group1.password
      }

      apiPasswordReminder.registerNew(params)
        .then(response => {

          if (response) {
            const { data } = response

            if (data) {
              const status = data.status ?? -1
              const errorMessage = data.error_message ?? ''

              if (status === 0) {
                // status=0: 成功

                router.push({ path: '/public/password-reminder/password-complete' })
              } else {
                // status=その他: エラーダイアログを表示
                store.dispatch('common/showNotice', { title: 'エラー', text: response.data.error_message })
              }
            }
          }
        })

    }
  })

  return group1
}
